// assets/announcement-bar.js
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.current = 0;
    this.interval = null;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
    this.autoplayInterval = parseInt(this.getAttribute('autoplay') || '6', 10) * 1000;
    if (this.slides.length > 1) this.start();
  }

  start() {
    this.stop();
    this.interval = setInterval(() => this.next(), this.autoplayInterval);
  }

  stop() {
    if (this.interval) clearInterval(this.interval);
  }

  next() {
    this.current = (this.current + 1) % this.slides.length;
    this.slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== this.current);
      slide.style.opacity = index === this.current ? '1' : '0';
      slide.style.transition = 'opacity 1s ease';
    });
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
 }
